// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getIsPunchOutSession, getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@west/App/Components/Common/XngZone";
import { EMPTY_VALUE } from "@west/XDL/constants";
import { xSiteMessage } from "@west/XDL/Utilities";
import React, { FC } from "react";
import { useDispatch } from "react-redux";

interface WelcomeHomeStyles {
    container?: InjectableCss;
    welcomeContainer?: InjectableCss;
    title?: TypographyPresentationProps;
    message?: LinkPresentationProps;
}

interface OwnProps extends WidgetProps {}

export const welcomeHomeStyles: WelcomeHomeStyles = {};

const styles = welcomeHomeStyles;
const WelcomeHome: FC<OwnProps> = ({ id }) => {
    const dispatch = useDispatch();
    const { name, isPunchOutSession } = useAppSelector(state => ({
        name: getSession(state).firstName || getSession(state).userName || EMPTY_VALUE,
        isPunchOutSession: getIsPunchOutSession(state),
    }));

    const signOutHandler = () => {
        dispatch(isPunchOutSession ? cancelPunchOut() : signOut({ redirectTo: "SignInPage" } as any));
    };

    const notYouMessage = xSiteMessage("Custom_Greet_Message")?.toString();

    return (
        <StyledWrapper {...styles.container} data-test-selector="welcome-home-widget">
            <StyledWrapper {...styles.welcomeContainer}>
                <Typography {...styles.title}>{siteMessage("Custom_Greeting_Message_Title", name)}</Typography>
                {notYouMessage &&
                    <Link onClick={signOutHandler} title={translate("Sign Out")} {...styles.message}>
                        {notYouMessage}
                    </Link>
                }
            </StyledWrapper>
            <XngZone contentId={id} zoneName="Content_Tabs" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: WelcomeHome,
    definition: {
        group: "Common",
        icon: "list-ul",
        fieldDefinitions: [],
    },
};

export default widgetModule;
